import { ConstrainedString } from '../generic'
import { MarkdownString } from '../MarkdownString'
import { Organization } from '../Organization/Organization'
import { ProposalOutcome } from '../ProposalOutcome/ProposalOutcome'
import { GM } from './GM'

export type ProposalId = ConstrainedString<'proposal-id'>

export interface Proposal {
  id: ProposalId
  title: string
  formattedDescription?: MarkdownString

  /**
   * If available, the outcome of the proposal as voted at the shareholders meeting.
   */
  outcome?: ProposalOutcome
  votingOptions?: VotingOption[]
}

export interface PollProposalRelationships {
  organization: Organization
  generalMeeting: GM
  proposal: Proposal
}

export enum VotingOption {
  For = 'for',
  Against = 'against',
  Abstain = 'abstain',
  Withhold = 'withhold',
  NoAction = 'no_action',
}
